module.exports = __webpack_public_path__ + "static/media/Stay in Control.1c4784a5.webp";